const localStorage = {
	setItem: function (key: string, value: unknown) {
		window.localStorage.setItem(key, JSON.stringify(value));
	},

	getItem: function <T = unknown>(key: string): T {
		const data = window.localStorage.getItem(key);
		try {
			return data ? JSON.parse(data) : null;
		} catch {
			return data as T;
		}
	},

	removeItem: function (key: string) {
		window.localStorage.removeItem(key);
	},

	hasItem: function (key: string) {
		return Boolean(window.localStorage.getItem(key));
	},
	clear: function () {
		window.localStorage.clear();
	},
};

export default localStorage;
